import axios from "axios";
import Vue from "vue";

export default {
  state: {
    loadingObservacao: false,
    listaObservacao: [],
    totalObservacao: 0,
    limiteObservacao: 10,
    codigoUnimed: 0,
    idEditando: 0,
    offsetTopElementoEditando: 0,
    mostrarModalEdicao: false,
    loadingObservacoes: false,
    paginaObservacao: 1,
    ocorreuErroObservacoes: false,
    pesquisandoObersavacao: false,
    totalPesquisaObservacao: 0,
    mostrarFiltroObservacoes: false,
    objetoFiltroObservacoes: {},
    textoFiltro: null
  },
  actions: {
    /**
     * Recupera os dados das observações, paginada
     * @param {{ cdUnimed: Number, pagina: Number, tamanho: Number }} params
     * @return {{
     *  "conteudo": [
     *  {
     *    "cdUnimed": Number,
     *        "dtCriacao": String,
     *        "id": Number,
     *        "texto": String
     *      }
     *    ],
     *    "numeroPagina": Number,
     *    "tamanhoPagina": Number,
     *    "totalElementos": Number,
     *    "totalPaginas": Number
     *  }}
     */
    async getObservacoes({ dispatch }, params) {
      return axios.get(
        await dispatch("CriarUrl", {
          resource: `adm/unimeds/observacoes`,
          params
        })
      );
    },
    /**
     * Exclui uma observação
     * @param {Number} idObservacao
     */
    async deleteObservacoes({ dispatch }, idObservacao) {
      return axios.delete(
        await dispatch("CriarUrl", {
          resource: `adm/unimeds/observacoes/${idObservacao}`
        })
      );
    },
    /**
     * Salva uma nova observação e retorna o objeto dela
     * @param {{
     *  params: {
     *    cdUnimed: Number
     *  },
     *  objetoObservacao: {
     *    texto: String
     *  }
     * }} objetoPost
     *
     * @return {Promise<{
     *   "texto": String,
     *   "id": Number,
     *   "cdUnimed": Number,
     *   "dtCriacao": String
     * }>}
     */
    async postObservacao({ dispatch }, { params, objetoObservacao }) {
      return axios.post(
        await dispatch("CriarUrl", {
          resource: `adm/unimeds/observacoes`,
          params
        }),
        objetoObservacao
      );
    },
    /**
     * Edita uma observação e retorna o objeto dela
     * @param {{
     *  idObservacao: Number,
     *  objetoObservacao: {
     *    texto: String
     *  }
     * }} objetoPut
     *
     * @return {Promise<{
     *   "texto": String,
     *   "id": Number,
     *   "cdUnimed": Number,
     *   "dtCriacao": String
     * }>}
     */
    async putObservacao({ dispatch }, { idObservacao, objetoObservacao }) {
      return axios.put(
        await dispatch("CriarUrl", {
          resource: `adm/unimeds/observacoes/${idObservacao}`
        }),
        objetoObservacao
      );
    },
    /**
     * Lazy-loading, acionado na hora de scrollar para o final da listagem
     */
    maisObservacoes({ dispatch, commit, state }) {
      if (state.listaObservacao === undefined) return;

      let idMaximo = Math.min(...state.listaObservacao.map(e => e.id)) - 1;

      const paginaAtual = state.paginaObservacao + 1;

      commit("setOcorreuErroObservacoes", false);
      commit("setLoadingObservacao", true);
      commit("setPaginaObservacao", paginaAtual);

      const params = {
        cdUnimed: state.codigoUnimed,
        pagina: 1,
        tamanho: 10,
        direcao: "DESC",
        ordenacao: "id",
        idMaximo
      };

      dispatch("getObservacoes", params)
        .then(res => {
          const { conteudo } = res.data;

          const observacoes = state.listaObservacao;
          conteudo.forEach(e => {
            observacoes.push(e);
          });
          commit(
            "setLimiteItemAtual",
            state.limiteObservacao + conteudo.length
          );
          commit("setListaObservacao", observacoes);
        })
        .catch(() => {
          commit("setOcorreuErroObservacoes", true);
        })
        .finally(() => {
          commit("setLoadingObservacao", false);
        });
    },
    /**
     * É chamado na ação de excluir o cartão
     * @param {Number} idObservacao
     */
    excluirObservacao({ dispatch, commit, state }, idObservacao) {
      commit("setLoadingModal", true);

      dispatch("deleteObservacoes", idObservacao)
        .then(() => {
          const observacoes = state.listaObservacao.filter(
            e => e.id !== idObservacao
          );
          const total = state.totalObservacao - 1;

          commit("setListaObservacao", observacoes);
          commit("setTotalObservacao", total);
          commit("setLimiteItemAtual", state.limiteObservacao - 1);
        })
        .catch(() => {
          commit("setCallbackFecharErro", () => {
            dispatch("inicializarObservacaoStore");
          });
        })
        .finally(() => {
          commit("setLoadingModal", false);
        });
    },
    /**
     * É chamado na ação de editar o cartão
     * @param {{
     *   idObservacao: this.objetoObservacao.id,
     *   texto: observacao
     * }} objetoEdicao
     */
    editarObservacao({ dispatch, commit, state }, objetoEdicao) {
      commit("setLoadingModal", true);

      dispatch("putObservacao", objetoEdicao)
        .then(res => {
          const observacoes = state.listaObservacao;
          const objetoObservacaoRes = res.data;
          const { id } = objetoObservacaoRes;
          const indexObservacao = observacoes.findIndex(e => e.id === id);

          Vue.set(observacoes, indexObservacao, objetoObservacaoRes);

          commit("setListaObservacao", observacoes);
        })
        .catch(() => {
          commit("setCallbackFecharErro", () => {
            dispatch("inicializarObservacaoStore");
          });
        })
        .finally(() => {
          commit("setIdEditando", 0);
          commit("setLoadingModal", false);
        });
    },
    /**
     * É chamado na ação de adicionar
     * @param { Object } objetoStore
     * @param { { observacao: String, callback: Function } } objeto
     */
    async salvarObservacao(
      { dispatch, commit, state },
      { observacao, callback }
    ) {
      if (state.pesquisandoObersavacao) {
        await dispatch("inicializarObservacaoStore");
      }
      commit("setLoadingModal", true);

      const params = {
        cdUnimed: state.codigoUnimed
      };
      const objetoObservacao = {
        texto: observacao
      };

      dispatch("postObservacao", {
        params,
        objetoObservacao
      })
        .then(res => {
          const objetoObservacaoRes = res.data;

          const observacoes = state.listaObservacao;
          observacoes.unshift(objetoObservacaoRes);

          commit("setTotalObservacao", state.totalObservacao + 1);
          commit("setLimiteItemAtual", state.limiteObservacao + 1);
          commit("setListaObservacao", observacoes);

          callback();

          this.$store.commit(
            "setSubtituloSucesso",
            `A observação foi adicionada.`
          );
          this.$store.commit("setMostrarSucessoModal", true);
        })
        .catch(() => {
          commit("setCallbackFecharErro", () => {
            dispatch("inicializarObservacaoStore");
          });
        })
        .finally(() => {
          commit("setLoadingModal", false);
        });
    },
    /**
     * É chamado na ação de pesquisar alguma observação
     * @param {Object} objetoStore
     * @param {String} texto
     */
    pesquisarObservacao({ state, dispatch, commit }, texto) {
      commit("setLoadingObservacoes", true);
      commit("setPesquisandoObservacao", true);

      state.textoFiltro = texto;

      const params = {
        cdUnimed: state.codigoUnimed,
        pagina: 1,
        tamanho: 10,
        direcao: "DESC",
        ordenacao: "id",
        busca: texto
      };

      dispatch("getObservacoes", params)
        .then(res => {
          const { conteudo, totalElementos } = res.data;
          commit("setListaObservacao", conteudo);
          commit("setTotalPesquisaObservacao", totalElementos);
          commit("setLimiteItemAtual", conteudo.length);
        })
        .finally(() => {
          commit("setLoadingObservacoes", false);
        });
    },
    /**
     * É chamado na ação de filtrar
     * @param { Object } objetoStore
     * @param objetoFiltro
     */
    filtrarObservacoes({ state, dispatch, commit }, objetoFiltro) {
      commit("setLoadingObservacoes", true);
      commit("setPesquisandoObservacao", true);

      let params = {
        cdUnimed: state.codigoUnimed,
        pagina: 1,
        tamanho: 10,
        direcao: "DESC",
        ordenacao: "id",
        ...objetoFiltro
      };

      if (state.texto) {
        params = {
          ...params,
          busca: state.texto
        };
      }

      dispatch("getObservacoes", params)
        .then(res => {
          const { conteudo, totalElementos } = res.data;
          commit("setListaObservacao", conteudo);
          commit("setTotalPesquisaObservacao", totalElementos);
          commit("setLimiteItemAtual", conteudo.length);
        })
        .finally(() => {
          commit("setLoadingObservacoes", false);
        });
    },
    /**
     * Serve para "resetar" a listagem de observações, é chamada em vários lugares
     */
    inicializarObservacaoStore({ state, dispatch, commit }) {
      return new Promise((resolve, reject) => {
        commit("setLoadingObservacoes", true);
        commit("setPesquisandoObservacao", false);

        state.mostrarFiltroObservacoes = false;
        state.objetoFiltroObservacoes = {};
        state.textoFiltro = null;

        const params = {
          cdUnimed: state.codigoUnimed,
          pagina: 1,
          tamanho: 10,
          direcao: "DESC",
          ordenacao: "id"
        };
        dispatch("getObservacoes", params)
          .then(res => {
            const { conteudo, totalElementos } = res.data;
            commit("setListaObservacao", conteudo);
            commit("setTotalObservacao", totalElementos);
            commit("setLimiteItemAtual", conteudo.length);
            resolve();
          })
          .catch(() => {
            reject();
          })
          .finally(() => {
            commit("setLoadingObservacoes", false);
          });
      });
    }
  },
  mutations: {
    setLoadingObservacao(state, _loading) {
      state.loadingObservacao = _loading;
    },
    setListaObservacao(state, _lista) {
      state.listaObservacao = _lista;
    },
    setTotalObservacao(state, _total) {
      state.totalObservacao = _total;
    },
    setLimiteItemAtual(state, _limite) {
      state.limiteObservacao = _limite;
    },
    setCodigoUnimedObservacao(state, _codigo) {
      state.codigoUnimed = _codigo;
    },
    setIdEditando(state, _id) {
      state.idEditando = _id;
    },
    setOffsetTopElementoEditando(state, _offset) {
      state.offsetTopElementoEditando = _offset;
    },
    setMostrarModalEdicao(state, _mostrar) {
      state.mostrarModalEdicao = _mostrar;
    },
    setLoadingObservacoes(state, _loading) {
      state.loadingObservacoes = _loading;
    },
    setPaginaObservacao(state, _pagina) {
      state.pagina = _pagina;
    },
    setOcorreuErroObservacoes(state, _erro) {
      state.ocorreuErroObservacoes = _erro;
    },
    setPesquisandoObservacao(state, _pesquisando) {
      state.pesquisandoObersavacao = _pesquisando;
    },
    setTotalPesquisaObservacao(state, _total) {
      state.totalPesquisaObservacao = _total;
    },
    setMostrarFiltroObservacoes(state, _mostrar) {
      state.mostrarFiltroObservacoes = _mostrar;
    },
    setObjetoFiltroObservacoes(state, _objeto) {
      state.objetoFiltroObservacoes = _objeto;
    }
  },
  getters: {
    getLoadingObservacao: state => state.loadingObservacao,
    getListaObservacao: state => state.listaObservacao,
    getTotalObservacao: state => state.totalObservacao,
    getLimiteObservacao: state => state.limiteObservacao,
    getIdEditando: state => state.idEditando,
    getOffsetTopElementoEditando: state => state.offsetTopElementoEditando,
    getMostrarModalEdicao: state => state.mostrarModalEdicao,
    getLoadingObservacoes: state => state.loadingObservacoes,
    getOcorreuErroObservacoes: state => state.ocorreuErroObservacoes,
    getPesquisandoObersavacao: state => state.pesquisandoObersavacao,
    getTotalPesquisaObservacao: state => state.totalPesquisaObservacao,
    getMostrarFiltroObservacoes: state => state.mostrarFiltroObservacoes,
    getObjetoFiltroObservacoes: state => state.objetoFiltroObservacoes
  }
};
